import { render, staticRenderFns } from "./SideBarRightRoundedHeader.vue?vue&type=template&id=046bd61a"
import script from "./SideBarRightRoundedHeader.vue?vue&type=script&lang=js"
export * from "./SideBarRightRoundedHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports